@if (searchService.searchError$ | async; as error) {
  <rotec-service-error-v2> </rotec-service-error-v2>
} @else {
  <div class="header-row">
    <rotec-radio-row-v2
      [options]="searchService.responsibleCompanyOptions"
      [selected]="state.responsibleCompanyFilterValue"
      [spaceEvenly]="true"
      (selectedChange)="searchService.filterForResponsible($event)"
    ></rotec-radio-row-v2>
  </div>
  <div class="task-search">
    <rotec-default-grid-v2
      [height]="gridHeight"
      [columns]="state.columns"
      [controlButtons]="controlButtons"
      (columnsChange)="updateColumnSettings($event)"
      [data]="state.searchData"
      (stateChange)="refineSearch($event)"
      [selectConfig]="{
        checkboxAlwaysVisible: true,
        checkboxToggleOnWholeRow: false,
      }"
      (rowClick)="openTask($event)"
      [noDataText]="noDataText"
      [filterButton]="false"
      (fulltextSearchChanged)="keyupEnterSearch($event)"
      (pageSizeChanged)="reactToPageSizeChange($event)"
      [selectedResults]="state.searchData.selectedIds"
      (selectedResultsChange)="searchService.setSelectedResults($event)"
      (selectedItemChanged)="toggleSelectedItem($event)"
      [fixedSpinner]="true"
    >
      <ng-template rotecGridCellV2="undo" let-dataItem="dataItem">
        @if (
          !isReactivateBtnDisabled(dataItem) && (userRightsService.hasActionRights$('Add') | async)
        ) {
          <p
            class="grid-text-cell"
            (click)="undoTask(dataItem, $event)"
            [class.disabled]="undoLoadingState.has(dataItem.id)"
          >
            <rotec-icon-v2 fontIcon="icon-undo2"></rotec-icon-v2>
          </p>
        }
      </ng-template>
      <ng-template rotecGridCellV2="toolingName" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.toolingName || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="manufacturer" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.manufacturer || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="inventoryNo" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.inventoryNo || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="serial" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.serial || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="schenckMatNo" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.schenckMatNo || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="verificationLevel" let-dataItem="dataItem">
        <p class="grid-text-cell">
          {{ dataItem.verificationLevel | rotecToolingVerificationLevel }}
        </p>
      </ng-template>
      <ng-template rotecGridCellV2="schenckId" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.schenckId || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="customerId" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.customerId || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="title" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.title || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="priority" let-dataItem="dataItem">
        <ma-priority
          class="grid-text-cell"
          [priority]="dataItem.priority"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-priority>
      </ng-template>
      <ng-template rotecGridCellV2="responsibleCompany" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.responsibleCompany || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="responsible" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.responsible || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="executive" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.executive || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="dueDate" let-dataItem="dataItem">
        <ma-date
          class="grid-text-cell"
          [date]="dataItem.dueDate"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-date>
      </ng-template>
      <ng-template rotecGridCellV2="executionDate" let-dataItem="dataItem">
        <ma-execution-date
          [date]="dataItem.executionDate"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-execution-date>
      </ng-template>
      <ng-template rotecGridCellV2="description" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.description || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="type" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.type | typeEnum }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="expectedDurationMinutes" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.expectedDurationMinutes || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="scheduling" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.scheduling | taskInterval }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="machines" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.machines || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="toolingForRotor" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.toolingForRotor || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="mainContact" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.mainContact || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="storageLocation" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.storageLocation || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="workplace" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.workplace || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="documentIds" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.documentIds || '-' }}</p>
      </ng-template>
    </rotec-default-grid-v2>
  </div>
}
